/* ===== vy-fastcart shared cart helper (same block in every -fastcart file; the first one that loads is used) ===== */
(function(){
  if (window.vyCart) return;
  var state = null, stamp = 0, inflight = null, seq = 0, busy = 0, hadErr = false;
  var shown = null, quietUntil = 0, deb = null, tTimer = null;
  var queue = Promise.resolve();
  var J = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  function noop(){}
  function each(sel, fn){ var l = document.querySelectorAll(sel); for (var i = 0; i < l.length; i++) fn(l[i]); }
  function setCounts(n){
    each('[data-cart-count]', function(el){ el.textContent = n; });
    var sc = document.querySelector('[data-custom-sticky-cart-count]');
    if (sc && n > 0) sc.textContent = n === 1 ? '1 Item' : n + ' Items';
    var root = document.getElementById('custom-sticky-cart');
    if (root && n > 0){ root.classList.add('is-on'); root.setAttribute('aria-hidden', 'false'); }
  }
  function headerCount(){
    if (state) return state.item_count;
    var el = document.querySelector('[data-cart-count]');
    return el ? (parseInt(el.textContent, 10) || 0) : 0;
  }
  function toast(on, isRemove){
    var t = document.getElementById('vy-added-toast');
    if (!t) return;
    clearTimeout(tTimer);
    if (!on){ t.classList.remove('is-on'); return; }
    t.classList.toggle('is-remove', !!isRemove);
    var m = t.querySelector('.vy-added-toast__msg');
    if (m) m.textContent = isRemove ? 'Item removed from your cart' : 'Item added to your cart';
    var p = t.querySelector('.vy-toast-plus'), mi = t.querySelector('.vy-toast-minus');
    if (p) p.style.display = isRemove ? 'none' : 'block';
    if (mi) mi.style.display = isRemove ? 'block' : 'none';
    t.classList.add('is-on');
    tTimer = setTimeout(function(){ t.classList.remove('is-on'); }, 2800);
  }
  function emit(cart){
    if (!cart || !cart.items) return;
    state = cart; stamp = Date.now(); shown = cart.item_count;
    setCounts(cart.item_count);
    document.dispatchEvent(new CustomEvent('vy:cart', { detail: cart }));
  }
  function get(maxAge, force){
    if (!force && state && Date.now() - stamp < (maxAge == null ? 1500 : maxAge)) return Promise.resolve(state);
    if (inflight && !force) return inflight;
    var my = ++seq;
    var p = fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        if (my === seq){ inflight = null; if (!busy) emit(c); }
        return c;
      }, function(e){ if (my === seq) inflight = null; throw e; });
    inflight = p;
    return p;
  }
  function pending(delta){
    if (!busy || shown == null) shown = headerCount();
    shown = Math.max(0, shown + delta);
    setCounts(shown);
    if (delta) toast(true, delta < 0);
    document.dispatchEvent(new CustomEvent('vy:cart:pending', { detail: { delta: delta } }));
  }
  function notifyTheme(){
    /* one event so the Bee theme refreshes its mini cart; our own listeners ignore it */
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { vyFast: true } }));
  }
  function finish(cart, err){
    busy--;
    if (err){ hadErr = true; try { console.warn('vyCart:', err); } catch(e){} }
    if (busy > 0){ if (err) throw err; return cart; }
    var bad = hadErr; hadErr = false;
    var done = (cart && cart.items && !bad) ? Promise.resolve(cart) : get(0, true);
    return done.then(function(c){
      if (c === cart) emit(c);
      if (bad) toast(false);
      quietUntil = Date.now() + 1000;
      notifyTheme();
      if (err) throw err;
      return c;
    });
  }
  function run(delta, op){
    pending(delta);
    busy++;
    var p = queue.then(op);
    queue = p.then(noop, noop);
    return p.then(function(c){ return finish(c, null); }, function(e){ return finish(null, e); });
  }
  function readJson(r){
    return r.json().then(function(d){
      if (!r.ok) throw new Error((d && (d.description || d.message)) || ('HTTP ' + r.status));
      return d;
    });
  }
  function add(id, qty){
    qty = parseInt(qty, 10) || 1;
    return run(qty, function(){
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: J, body: JSON.stringify({ id: id, quantity: qty }) })
        .then(readJson).then(function(){ return null; });
    });
  }
  function change(id, qty, delta){
    return run(delta || 0, function(){
      return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: J, body: JSON.stringify({ id: String(id), quantity: qty }) })
        .then(readJson);
    });
  }
  function refresh(e){
    if (e && e.detail && e.detail.vyFast) return;
    if (busy || Date.now() < quietUntil) return;
    clearTimeout(deb);
    deb = setTimeout(function(){ get(0, true).catch(noop); }, 150);
  }
  window.vyCart = { get: get, add: add, change: change, refresh: refresh, state: function(){ return state; }, busy: function(){ return busy > 0; } };
})();
(function () {
  var BHAKHRI_IMG =
      "https://cdn.shopify.com/s/files/1/0780/3636/9629/files/Farali_bhakhro_copy.png?v=1788590037",
    KHAKHRA_IMG =
      "https://cdn.shopify.com/s/files/1/0780/3636/9629/files/chorafali_463ccd03-4208-4387-8d1f-6712e9e62d5d.png?v=1788592938",
    SOYA_IMG =
      "https://cdn.shopify.com/s/files/1/0780/3636/9629/files/soya_chalks_1.png?v=1788769518",
    SEV_IMG =
      "https://cdn.shopify.com/s/files/1/0780/3636/9629/files/Gemini_Generated_Image11_znm0eznm0eznm0ez_2_copy.png?v=1788776799",
    NAMKEEN_IMG =
      "https://cdn.shopify.com/s/files/1/0780/3636/9629/files/chevda_2.png?v=1790317209",
    BREAK_DURATION = 850,
    CUT_DURATION = 900,
    SNAP_DURATION = 1050,
    SEV_DURATION = 1100,
    NAMKEEN_DURATION = 1450,
    PRAY_DURATION = 1700,
    vyBreaking = !1,
    BITE_ORIGIN_LEFT = 82,
    BITE_ORIGIN_TOP = 10,
    UPVAS_HANDS_IMG =
      "https://cdn.shopify.com/s/files/1/0780/3636/9629/files/aGi8m_1.png?v=1788846852";
  function spawnDebris(stage, delayMs, leftPct, topPct, count, isShard) {
    ((count = count || 12), (isShard = isShard !== void 0 ? isShard : !0));
    for (
      var colors = [
          "#c98a4b",
          "#e0a86c",
          "#8a5a2b",
          "#f2c88f",
          "#d97706",
          "#b87a3a",
          "#a86a2f",
        ],
        c = 0;
      c < count;
      c++
    ) {
      var el = document.createElement("span"),
        shard = Math.random() > 0.6 && isShard;
      el.className = shard ? "vy-shard" : "vy-crumb";
      var size = shard ? 4 + Math.random() * 14 : 2 + Math.random() * 8,
        angle = Math.random() * 360 * (Math.PI / 180),
        dist = Math.random() * 70 + 15,
        tx = Math.cos(angle) * dist * (0.4 + Math.random() * 1),
        ty = Math.sin(angle) * dist * (0.4 + Math.random() * 1) - 10,
        color = colors[Math.floor(Math.random() * colors.length)],
        individualDelay = delayMs + Math.random() * 30,
        shape = shard
          ? "polygon(30% 0%, 85% 10%, 100% 50%, 70% 95%, 15% 80%, 0% 25%)"
          : "50%";
      ((el.style.cssText =
        "width:" +
        size +
        "px;height:" +
        size +
        "px;background:" +
        color +
        ";left:" +
        (leftPct + (Math.random() - 0.5) * 6) +
        "%;top:" +
        (topPct + (Math.random() - 0.5) * 6) +
        "%;--tx:" +
        tx +
        "px;--ty:" +
        ty +
        "px;animation-delay:" +
        individualDelay +
        "ms;clip-path:" +
        shape +
        ";border-radius:" +
        (shard ? "0" : "50%") +
        ";opacity:0;"),
        stage.appendChild(el));
    }
  }
  function playBhakhriBreak() {
    if (!vyBreaking) {
      vyBreaking = !0;
      var overlay = document.createElement("div");
      overlay.className = "vy-break-overlay";
      var stage = document.createElement("div");
      stage.className = "vy-break-stage";
      var img = document.createElement("img");
      ((img.src = BHAKHRI_IMG),
        (img.className = "vy-bite-img"),
        (img.alt = ""),
        stage.appendChild(img),
        overlay.appendChild(stage),
        document.body.appendChild(overlay),
        overlay.offsetWidth,
        overlay.classList.add("is-on"),
        setTimeout(function () {
          overlay.parentNode &&
            spawnDebris(stage, 0, BITE_ORIGIN_LEFT, BITE_ORIGIN_TOP, 8, !1);
        }, 150),
        setTimeout(function () {
          (overlay.classList.remove("is-on"),
            setTimeout(function () {
              (overlay.parentNode && overlay.parentNode.removeChild(overlay),
                (vyBreaking = !1));
            }, 260));
        }, BREAK_DURATION + 80));
    }
  }
  function playKhakhraCut() {
    if (!vyBreaking) {
      vyBreaking = !0;
      var overlay = document.createElement("div");
      overlay.className = "vy-break-overlay";
      var stage = document.createElement("div");
      stage.className = "vy-break-stage";
      var left = document.createElement("img");
      ((left.src = KHAKHRA_IMG),
        (left.className = "vy-cut-half vy-cut-left"),
        (left.alt = ""),
        stage.appendChild(left));
      var right = document.createElement("img");
      ((right.src = KHAKHRA_IMG),
        (right.className = "vy-cut-half vy-cut-right"),
        (right.alt = ""),
        stage.appendChild(right));
      var flash = document.createElement("div");
      ((flash.className = "vy-cut-flash"),
        stage.appendChild(flash),
        overlay.appendChild(stage),
        document.body.appendChild(overlay),
        overlay.offsetWidth,
        overlay.classList.add("is-on"),
        setTimeout(function () {
          overlay.parentNode && spawnDebris(stage, 0, 50, 50, 12, !0);
        }, 160),
        setTimeout(function () {
          (overlay.classList.remove("is-on"),
            setTimeout(function () {
              (overlay.parentNode && overlay.parentNode.removeChild(overlay),
                (vyBreaking = !1));
            }, 260));
        }, CUT_DURATION + 80));
    }
  }
  function playSoyaSnap() {
    if (!vyBreaking) {
      vyBreaking = !0;
      var overlay = document.createElement("div");
      overlay.className = "vy-break-overlay";
      var stage = document.createElement("div");
      stage.className = "vy-break-stage";
      var topHalf = document.createElement("img");
      ((topHalf.src = SOYA_IMG),
        (topHalf.className = "vy-snap-half vy-snap-top"),
        (topHalf.alt = ""),
        stage.appendChild(topHalf));
      var bottomHalf = document.createElement("img");
      ((bottomHalf.src = SOYA_IMG),
        (bottomHalf.className = "vy-snap-half vy-snap-bottom"),
        (bottomHalf.alt = ""),
        stage.appendChild(bottomHalf),
        overlay.appendChild(stage),
        document.body.appendChild(overlay),
        overlay.offsetWidth,
        overlay.classList.add("is-on"),
        setTimeout(function () {
          overlay.parentNode &&
            (spawnDebris(stage, 0, 48, 49, 8, !1),
            spawnDebris(stage, 20, 50, 50, 6, !1));
        }, 400),
        setTimeout(function () {
          (overlay.classList.remove("is-on"),
            setTimeout(function () {
              (overlay.parentNode && overlay.parentNode.removeChild(overlay),
                (vyBreaking = !1));
            }, 260));
        }, SNAP_DURATION + 80));
    }
  }
  function playSevRain() {
    if (!vyBreaking) {
      vyBreaking = !0;
      var overlay = document.createElement("div");
      overlay.className = "vy-break-overlay";
      var stage = document.createElement("div");
      stage.className = "vy-break-stage";
      var bowl = document.createElement("img");
      ((bowl.src = SEV_IMG),
        (bowl.className = "vy-sev-bowl"),
        (bowl.alt = ""),
        stage.appendChild(bowl));
      var wrap = document.createElement("div");
      wrap.className = "vy-sev-fallwrap";
      for (
        var clips = [
            "polygon(46% 24%, 53% 23%, 55% 29%, 48% 31%)",
            "polygon(50% 22%, 57% 24%, 56% 30%, 49% 28%)",
            "polygon(41% 26%, 48% 25%, 49% 32%, 42% 33%)",
            "polygon(54% 25%, 61% 27%, 59% 33%, 53% 32%)",
            "polygon(44% 28%, 51% 27%, 52% 34%, 45% 35%)",
            "polygon(48% 26%, 54% 25%, 55% 32%, 47% 33%)",
            "polygon(52% 23%, 58% 22%, 59% 28%, 52% 29%)",
            "polygon(43% 24%, 49% 23%, 50% 30%, 43% 31%)",
          ],
          i = 0;
        i < clips.length;
        i++
      ) {
        var bit = document.createElement("img");
        ((bit.src = SEV_IMG), (bit.className = "vy-sev-bit"), (bit.alt = ""));
        var r0 = Math.random() * 16 - 8,
          r1 = r0 + (Math.random() * 10 - 5);
        ((bit.style.cssText =
          "clip-path:" +
          clips[i] +
          ";--r0:" +
          r0 +
          "deg;--r1:" +
          r1 +
          "deg;animation-delay:" +
          (40 + i * 55) +
          "ms;"),
          wrap.appendChild(bit));
      }
      (stage.appendChild(wrap),
        overlay.appendChild(stage),
        document.body.appendChild(overlay),
        overlay.offsetWidth,
        overlay.classList.add("is-on"),
        setTimeout(function () {
          (overlay.classList.remove("is-on"),
            setTimeout(function () {
              (overlay.parentNode && overlay.parentNode.removeChild(overlay),
                (vyBreaking = !1));
            }, 260));
        }, SEV_DURATION + 80));
    }
  }
  function playNamkeenRain() {
    if (!vyBreaking) {
      vyBreaking = !0;
      var overlay = document.createElement("div");
      overlay.className = "vy-break-overlay";
      var stage = document.createElement("div");
      stage.className = "vy-break-stage";
      var bowl = document.createElement("img");
      ((bowl.src = NAMKEEN_IMG),
        (bowl.className = "vy-nk-bowl"),
        (bowl.alt = ""),
        stage.appendChild(bowl));
      for (
        var clips = [
            "polygon(45% 22%, 54% 21%, 55% 30%, 46% 31%)",
            "polygon(50% 18%, 59% 20%, 58% 29%, 49% 27%)",
            "polygon(36% 26%, 45% 24%, 46% 34%, 37% 35%)",
            "polygon(56% 24%, 66% 26%, 64% 36%, 55% 34%)",
            "polygon(42% 28%, 51% 27%, 52% 37%, 43% 38%)",
            "polygon(48% 25%, 57% 24%, 58% 33%, 49% 34%)",
            "polygon(53% 20%, 62% 19%, 63% 28%, 54% 29%)",
            "polygon(39% 23%, 48% 22%, 49% 32%, 40% 33%)",
            "polygon(33% 30%, 41% 29%, 42% 38%, 34% 39%)",
            "polygon(60% 29%, 68% 30%, 67% 39%, 59% 38%)",
            "polygon(47% 31%, 55% 30%, 56% 39%, 48% 40%)",
            "polygon(44% 19%, 52% 18%, 53% 26%, 45% 27%)",
          ],
          i = 0;
        i < clips.length;
        i++
      ) {
        var bit = document.createElement("img");
        ((bit.src = NAMKEEN_IMG),
          (bit.className = "vy-nk-bit"),
          (bit.alt = ""));
        var r0 = -30 + Math.random() * 60,
          r1 = r0 + (-12 + Math.random() * 24),
          r2 = r1 + (-8 + Math.random() * 16),
          sx = -18 + Math.random() * 36 + "px";
        ((bit.style.cssText =
          "clip-path:" +
          clips[i] +
          ";--r0:" +
          r0 +
          "deg;--r1:" +
          r1 +
          "deg;--r2:" +
          r2 +
          "deg;--sx:" +
          sx +
          ";animation-delay:" +
          (80 + i * 70) +
          "ms;"),
          stage.appendChild(bit));
      }
      var peanuts = [
        { left: "42%", top: "34%", delay: 220 },
        { left: "55%", top: "31%", delay: 360 },
        { left: "48%", top: "38%", delay: 510 },
        { left: "61%", top: "36%", delay: 680 },
        { left: "38%", top: "37%", delay: 820 },
      ];
      (peanuts.forEach(function (p) {
        var nut = document.createElement("span");
        ((nut.className = "vy-nk-peanut"),
          (nut.style.cssText =
            "left:" +
            p.left +
            ";top:" +
            p.top +
            ";animation-delay:" +
            p.delay +
            "ms;"),
          stage.appendChild(nut));
      }),
        overlay.appendChild(stage),
        document.body.appendChild(overlay),
        overlay.offsetWidth,
        overlay.classList.add("is-on"),
        setTimeout(function () {
          (overlay.classList.remove("is-on"),
            setTimeout(function () {
              (overlay.parentNode && overlay.parentNode.removeChild(overlay),
                (vyBreaking = !1));
            }, 260));
        }, NAMKEEN_DURATION + 80));
    }
  }
  function playUpvasPray() {
    if (!vyBreaking) {
      vyBreaking = !0;
      var overlay = document.createElement("div");
      ((overlay.className = "vy-break-overlay"),
        (overlay.style.background = "rgba(0,0,0,0.62)"));
      var stage = document.createElement("div");
      stage.className = "vy-pray-stage";
      var glow = document.createElement("div");
      ((glow.className = "vy-pray-glow"), stage.appendChild(glow));
      var left = document.createElement("img");
      ((left.src = UPVAS_HANDS_IMG),
        (left.alt = ""),
        (left.className = "vy-pray-half vy-pray-left"),
        stage.appendChild(left));
      var right = document.createElement("img");
      ((right.src = UPVAS_HANDS_IMG),
        (right.alt = ""),
        (right.className = "vy-pray-half vy-pray-right"),
        stage.appendChild(right));
      for (
        var colors = [
            "#fe5119",
            "#f59e0b",
            "#fbbf24",
            "#fb7185",
            "#fdba74",
            "#facc15",
            "#ffffff",
          ],
          i = 0;
        i < 18;
        i++
      ) {
        var petal = document.createElement("span");
        petal.className = "vy-petal";
        var size = 8 + Math.random() * 12,
          leftPct = 8 + Math.random() * 84,
          dx = Math.random() * 70 - 35,
          spin = (180 + Math.random() * 220) * (Math.random() > 0.5 ? 1 : -1),
          dur = 700 + Math.random() * 450,
          delay = 180 + Math.random() * 420;
        ((petal.style.cssText =
          "left:" +
          leftPct +
          "%;width:" +
          size +
          "px;height:" +
          size +
          "px;--petal:" +
          colors[i % colors.length] +
          ";--dx:" +
          dx +
          "px;--spin:" +
          spin +
          "deg;animation-duration:" +
          dur +
          "ms;animation-delay:" +
          delay +
          "ms;"),
          stage.appendChild(petal));
      }
      (overlay.appendChild(stage),
        document.body.appendChild(overlay),
        overlay.offsetWidth,
        overlay.classList.add("is-on"),
        setTimeout(function () {
          (overlay.classList.remove("is-on"),
            setTimeout(function () {
              (overlay.parentNode && overlay.parentNode.removeChild(overlay),
                (vyBreaking = !1));
            }, 260));
        }, PRAY_DURATION + 80));
    }
  }
  function spawnFireworkBlast(stage, xPct, yPct, delay, count) {
    var colors = [
        "#fe5119",
        "#ffd36a",
        "#ffffff",
        "#ff8a5c",
        "#facc15",
        "#fb7185",
        "#60a5fa",
      ],
      burst = document.createElement("span");
    ((burst.className = "vy-fw-burst"),
      (burst.style.cssText =
        "--x:" + xPct + "%;--y:" + yPct + "%;--delay:" + delay + "ms;"),
      stage.appendChild(burst),
      (count = count || 26));
    for (var i = 0; i < count; i++) {
      var spark = document.createElement("span");
      spark.className = "vy-fw-spark";
      var angle = (i / count) * Math.PI * 2 + Math.random() * 0.25,
        dist = 70 + Math.random() * 110,
        size = 3 + Math.random() * 5;
      ((spark.style.cssText =
        "--x:" +
        xPct +
        "%;--y:" +
        yPct +
        "%;--s:" +
        size +
        "px;--c:" +
        colors[Math.floor(Math.random() * colors.length)] +
        ";--tx:" +
        Math.cos(angle) * dist +
        "px;--ty:" +
        (Math.sin(angle) * dist + 18) +
        "px;--delay:" +
        (delay + Math.random() * 40) +
        "ms;"),
        stage.appendChild(spark));
    }
  }
  function playComboFireworks() {
    if (!vyBreaking) {
      vyBreaking = !0;
      var overlay = document.createElement("div");
      overlay.className = "vy-break-overlay vy-fw-overlay";
      var stage = document.createElement("div");
      ((stage.className = "vy-fw-stage"),
        overlay.appendChild(stage),
        document.body.appendChild(overlay),
        overlay.offsetWidth,
        overlay.classList.add("is-on"));
      var rockets = [
        { x: 22, fly: 980, blastY: 28, wait: 40 },
        { x: 50, fly: 1100, blastY: 22, wait: 180 },
        { x: 78, fly: 1020, blastY: 30, wait: 320 },
        { x: 36, fly: 1180, blastY: 38, wait: 520 },
        { x: 64, fly: 1240, blastY: 36, wait: 680 },
      ];
      (rockets.forEach(function (r) {
        var rocket = document.createElement("span");
        rocket.className = "vy-fw-rocket";
        var up = -(window.innerHeight * (1 - r.blastY / 100) + 40);
        ((rocket.style.cssText =
          "--x:" +
          r.x +
          "%;--up:" +
          up +
          "px;--dur:" +
          r.fly +
          "ms;--delay:" +
          r.wait +
          "ms;"),
          stage.appendChild(rocket),
          spawnFireworkBlast(stage, r.x, r.blastY, r.wait + r.fly - 40, 28));
      }),
        setTimeout(function () {
          (overlay.classList.remove("is-on"),
            setTimeout(function () {
              (overlay.parentNode && overlay.parentNode.removeChild(overlay),
                (vyBreaking = !1));
            }, 260));
        }, 2100));
    }
  }
  if (window.__vyLovedBound) return;
  window.__vyLovedBound = !0;
  function showStep(card, qty) {
    var add = card.querySelector(".vy-loved-add"),
      step = card.querySelector(".vy-loved-step"),
      num = card.querySelector(".vy-loved-qty");
    step &&
      ((qty = parseInt(qty, 10) || 0),
      qty > 0
        ? (add && (add.style.display = "none"),
          (step.style.display = "flex"),
          num && (num.textContent = qty))
        : (add &&
            ((add.style.display = "block"),
            (add.disabled = !1),
            (add.textContent = "Add to cart")),
          (step.style.display = "none"),
          num && (num.textContent = "0")));
  }
  function syncLovedCardsFromCart(cart) {
    if (!(!cart || !cart.items)) {
      var counts = {};
      (cart.items.forEach(function (item) {
        var vid = String(item.variant_id || item.id);
        counts[vid] = (counts[vid] || 0) + (parseInt(item.quantity, 10) || 0);
      }),
        document
          .querySelectorAll(".vy-loved-card[data-id]")
          .forEach(function (card) {
            var id = String(card.getAttribute("data-id") || "");
            showStep(card, counts[id] || 0);
          }));
    }
  }
  function loadCartAndSyncLoved() {
    return window.vyCart
      .get()
      .then(function (cart) {
        return (syncLovedCardsFromCart(cart), cart);
      })
      .catch(function () {});
  }
  /* fast cart: show the new quantity at once, then save it in the background */
  function setQty(id, qty, card, cur) {
    showStep(card, qty);
    return window.vyCart.change(id, qty, qty - cur).catch(function () {});
  }
  function addOne(id, card, cur) {
    showStep(card, (cur || 0) + 1);
    return window.vyCart.add(id, 1).catch(function () {});
  }
  (document.addEventListener("click", function (e) {
    var tab = e.target.closest(".vy-loved-tab");
    if (tab) {
      if (tab.tagName === "A") return;
      var id = tab.getAttribute("data-tab"),
        wasOn = tab.classList.contains("is-on");
      (document.querySelectorAll(".vy-loved-tab").forEach(function (t) {
        t.classList.toggle("is-on", t === tab);
      }),
        document.querySelectorAll(".vy-loved-panel").forEach(function (p) {
          p.classList.toggle("is-on", p.getAttribute("data-panel") === id);
        }),
        id === "bhakhri" && !wasOn && playBhakhriBreak(),
        id === "khakhara" && !wasOn && playKhakhraCut(),
        id === "soya" && !wasOn && playSoyaSnap(),
        id === "sev" && !wasOn && playSevRain(),
        id === "namkeen" && !wasOn && playNamkeenRain(),
        id === "combos" && !wasOn && playComboFireworks(),
        id === "upvas" && !wasOn && playUpvasPray());
      return;
    }
    var arrow = e.target.closest(".vy-loved-arrow");
    if (arrow) {
      var row = arrow.parentNode.querySelector(".vy-loved-row");
      if (!row) return;
      var move = row.clientWidth * 0.8;
      row.scrollBy({
        left: arrow.classList.contains("vy-loved-next") ? move : -move,
        behavior: "smooth",
      });
      return;
    }
    var card = e.target.closest(".vy-loved-card");
    if (card) {
      var vid = card.getAttribute("data-id"),
        qtyEl = card.querySelector(".vy-loved-qty"),
        qty = (qtyEl && parseInt(qtyEl.textContent, 10)) || 0;
      if (e.target.closest(".vy-loved-add") && !e.target.disabled) {
        (e.preventDefault(), addOne(vid, card, qty));
        return;
      }
      if (e.target.closest(".vy-loved-plus")) {
        (e.preventDefault(), setQty(vid, qty + 1, card, qty));
        return;
      }
      e.target.closest(".vy-loved-minus") &&
        (e.preventDefault(), setQty(vid, Math.max(0, qty - 1), card, qty));
    }
  }),
    document.readyState !== "loading"
      ? loadCartAndSyncLoved()
      : document.addEventListener("DOMContentLoaded", loadCartAndSyncLoved),
    document.addEventListener("vy:cart", function (e) {
      syncLovedCardsFromCart(e.detail);
    }),
    window.addEventListener("pageshow", function (e) {
      e.persisted && window.vyCart.refresh();
    }),
    document.addEventListener("cart:refresh", window.vyCart.refresh),
    fetch("https://ipapi.co/json/")
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var city = (data.city || "").toLowerCase(),
          state = (data.region || "").toLowerCase(),
          days = 5;
        city.indexOf("ahmedabad") > -1 || city.indexOf("amdavad") > -1
          ? (days = 1)
          : (state.indexOf("maharashtra") > -1 ||
              state.indexOf("delhi") > -1 ||
              state.indexOf("gujarat") > -1) &&
            (days = 2);
        var txt = days === 1 ? "in 1 day" : "in " + days + " days";
        document.querySelectorAll(".vy-delivery-date").forEach(function (el) {
          el.textContent = txt;
        });
      })
      .catch(function () {}));
})();
